<template>
	<div style="background: #f5f5f5;">
		<!-- banner -->
		<banner></banner>
		<!-- banner end -->
		
		<!-- 公司简介 -->
		<company-profile></company-profile>
		<!-- 公司简介 end -->
		
		<!-- 依托机构 -->
		<supporting-institutions></supporting-institutions>
		<!-- 依托机构 end -->
		
		<!-- 企业文化 -->
		<culture></culture>
		<!-- 企业文化 end -->
		
		<!-- 成长历程 -->
		<growth-process></growth-process>
		<!-- 成长历程 end -->
		
		<!-- 持续发展 -->
		<development></development>
		<!-- 持续发展 end -->
	</div>
</template>

<script>
	import Banner from './components/banner.vue';
	import CompanyProfile from './components/company_profile.vue';
	import SupportingInstitutions from './components/supporting_institutions.vue';
	import Culture from './components/culture.vue';
	import GrowthProcess from './components/growth_process.vue';
	import Development from './components/development.vue';
	
	export default {
		components: {
			Banner,
			CompanyProfile,
			SupportingInstitutions,
			Culture,
			GrowthProcess,
			Development
		}
	}
</script>

<style scoped>
	
</style>
